Alpine.directive("virtual-props", (_, { expression }, {evaluateLater, evaluate}) => {
    let data = evaluate('$data');
    const getProps = evaluateLater(expression);

    getProps(props => {
        data.options = props;
        data.prepare();
    });
});
